// This icon file is generated automatically.
var PLoginOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7.15.28a6.72 6.72 0 00-5.68 3.09c-.05.08.01.2.1.2h1.1c.08 0 .15-.04.2-.1.1-.13.23-.26.35-.38a5.53 5.53 0 11-.35 7.44.25.25 0 00-.2-.1h-1.1c-.09 0-.15.12-.1.2A6.72 6.72 0 107.15.28zM5.17 8.75V7.56H.27a.13.13 0 01-.13-.12v-.88c0-.07.06-.12.13-.12h4.9V5.25c0-.1.12-.16.2-.1L7.6 6.9c.07.05.07.15 0 .2L5.38 8.85c-.09.06-.2 0-.2-.1z", "fill-rule": "nonzero" } }] }, "name": "p-login", "theme": "outlined" };
export default PLoginOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLoginOutlined.js
// module id = 3494
// module chunks = 0